import * as React from "react";

function SvgFindIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} {...props}>
      <path
        data-name="Caminho 247"
        d="M16.352 15.63l-3.082-3.081a7.285 7.285 0 10-.719.719l3.082 3.081a.514.514 0 00.36.151.5.5 0 00.36-.151.512.512 0 00-.001-.719zM1.518 7.777a6.257 6.257 0 116.257 6.259 6.263 6.263 0 01-6.257-6.259z"
        fill="#6b7384"
        stroke="#6b7384"
      />
    </svg>
  );
}

export default SvgFindIcon;

